import { isUsuarioUsoMuto } from 'utils';
import { FOLHA_PONTO_OLD, PEDIDO_VOO, CALENDARIO_FERIADOS_ADMIN } from 'constants/modules';
import { isRoleAuditoriaNsir } from '../../../../helpers/auditoriaNsirPermission';
import { isAdmin, INSPETOR } from 'constants/role';

/**
 * Itens dinâmicos de Folha de Ponto para o menu lateral (formato legado: href).
 */
export const renderFolhaPonto = (authData, moduleConfigurations) => {
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role)) return [];

  const options = [];
  const showOld = moduleConfigurations?.find(
    u => u.codigo === FOLHA_PONTO_OLD && u.userId === authData.id
  );
  if (showOld) {
    options.push({
      title: 'Folha de Ponto (Antigo)',
      href: '/folha-pontos',
      show: true,
      key: 'inspecao',
    });
  }

  options.push({
    title: 'Folha de Ponto',
    href: '/v2/folha-pontos',
    show: true,
    key: 'inspecao',
  });

  return options;
};

export const renderPedidoVoo = (authData, moduleConfigurations) => {
  const isCustomRole = isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role)
  const rolePermission = isAdmin(authData.role) || authData.role === INSPETOR;

  if (isCustomRole || !rolePermission) return [];

  const options = [];
  const show = moduleConfigurations?.find(
    u => u.codigo === PEDIDO_VOO && (u.userId === authData.id || u.userId === null)
  );
  if (show) {
    options.push({
      title: 'Pedidos de Voo',
      href: '/v2/pedidos-voo',
      show: true,
      key: 'inspecao',
    });
  }

  return options;
};

/**
 * Item "Gestão de Feriados" (tela admin) — visível somente com a permissão
 * `CALENDARIO_FERIADOS_ADMIN` ou para admin/super-admin (mesmo padrão condicional
 * de `renderPedidoVoo`).
 */
export const renderCalendarioFeriadosAdmin = (authData, moduleConfigurations) => {
  const options = [];
  const show =
    isAdmin(authData.role) ||
    moduleConfigurations?.find(
      (u) => u.codigo === CALENDARIO_FERIADOS_ADMIN && (u.userId === authData.id || u.userId === null)
    );
  if (show) {
    options.push({
      title: 'Gestão de Feriados',
      href: '/v2/calendario-admin',
      show: true,
      key: 'configurations',
    });
  }

  return options;
};
